import axios from "axios";

export const state = {
    memberinterests: [],
};

export const getters = {
    memberinterests: state => state.memberinterests,
};

export const mutations = {
    setMemberInterest(state, newValue) {
        state.memberinterests = newValue
    },
};

export const actions = {
    async fetchMemberInterest({ commit }) {
        await axios.get('/memberinterests').then(res => {
            commit('setMemberInterest', res.data.payouts)
        })
    },
};
